import { Modal } from "react-bootstrap";
import React from "react";

const SideModal = ({ title, children, handleClose, visible, width }) => {
  return (
    <div>
      <Modal className={`right ${width}`} show={visible} onHide={handleClose}>
        <Modal.Header closeButton>{title}</Modal.Header>
        <Modal.Body>{children}</Modal.Body>
      </Modal>
    </div>
  );
};

export default SideModal;
